import React from 'react'
import createReactClass from 'create-react-class'
import SearchPanelContainer from '../containers/search/search-panel-container'

export default createReactClass({
  render () {
    return (
      <section>
        <SearchPanelContainer {...this.props}/>
      </section>
    )
  },
})



// WEBPACK FOOTER //
// ./src/views/search.js